// extracted by mini-css-extract-plugin
export default {"main_container":"AppContainer_main_container__Pf4ET","middlepanel_container":"AppContainer_middlepanel_container__AX4pg","drawer":"AppContainer_drawer__XU4Cn"};